import React from "react";
import { CACHE_CATEGORY } from "src/constants/actionCache";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { useState } from "react";
import ShowCacheFLFCategory from "../ShowCache/ShowCacheFLFCategory";
import FLFCategoryPopup from "../Popup/FLFCategoryPopup";
import Controls from "src/components/form/controls/Controls";

const FLFCategoryControlPanel = ({
  children,
  isSorted,
  handleSort,
  currentActionCache,
  recordForEdit,
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  addOrEdit,
  errorsForm,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
      <div>
        <DeployCache
          title="Cache Categories"
          isShowButton={isShowCache(currentActionCache, CACHE_CATEGORY)}
        >
          <ShowCacheFLFCategory
            disableButton={disableButton}
            setDisableButton={setDisableButton}
          />
        </DeployCache>
        {isSorted ? (
          <Controls.Button
            text="Apply sort"
            variant="outlined"
            onClick={handleSort}
          />
        ) : null}
        <FLFCategoryPopup
          recordForEdit={recordForEdit}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          handleOpenPopup={handleOpenPopup}
          addOrEdit={addOrEdit}
          errorsForm={errorsForm}
        />
      </div>
    </div>
  );
};

export default FLFCategoryControlPanel;
